import { render, staticRenderFns } from "./MKBankButton.vue?vue&type=template&id=ce853dbe&scoped=true&"
import script from "./MKBankButton.vue?vue&type=script&lang=js&"
export * from "./MKBankButton.vue?vue&type=script&lang=js&"
import style0 from "./MKBankButton.vue?vue&type=style&index=0&id=ce853dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce853dbe",
  null
  
)

export default component.exports